import { getStore, AppStoreLike } from "@store";
import { addBatchCall, loadBatchCall } from "@actions/global";

/**
 * Store handle used by batch-call helpers. Widened to AppStoreLike so both the
 * full global store (via the deprecated getStore() default) AND `{ dispatch,
 * getState }` closures constructed inside RTK thunks satisfy the signature.
 */
type Store = AppStoreLike;

interface BatchCallEntry {
  callType: string;
  timeID: number;
}

export const trackBatchCall = (
  callType: string,
  store: Store = getStore()
): number => {
  const timeID = new Date().getTime();
  store.dispatch(addBatchCall(callType, timeID as unknown as string));
  return timeID;
};

export const isLastBatchCallUpToDate = (
  timeID: number,
  callType: string,
  store: Store = getStore()
): boolean => {
  const batchCalls: BatchCallEntry[] = store.getState().config.batchCalls;
  let batchCallToClean: BatchCallEntry | null = null;
  const matchedBatchCalls = batchCalls
    ? batchCalls.filter((call) => {
      const filter =
        call.callType === callType && call.timeID <= timeID ? call : null;
      batchCallToClean =
        call.callType === callType && call.timeID === timeID
          ? call
          : batchCallToClean;
      return !filter;
    })
    : [];
  store.dispatch(loadBatchCall(matchedBatchCalls));
  return !matchedBatchCalls.length && !!batchCallToClean;
};

export const invalidateBatchCall = (
  callType: string,
  store: Store = getStore()
): void => {
  const batchCalls: BatchCallEntry[] = store.getState().config.batchCalls;
  const batchCallsToClean: BatchCallEntry[] = [];
  const batchCallWithoutType = batchCalls
    ? batchCalls.filter((call) => {
      if (call.callType === callType) {
        batchCallsToClean.push(call);
      }
      return !(call.callType === callType);
    })
    : [];
  if (batchCallsToClean.length > 0) {
    store.dispatch(loadBatchCall(batchCallWithoutType));
  }
};
